import React from 'react';

const {
  BrowserRouter: Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} = require('react-router-dom');
require('./App.css');
require('./index.css');

const Header = require('./components/Header').default;
const SiteHeader = require('./components/SiteHeader').default;
const Main = require('./components/Main').default;
const Team = require('./components/Team').default;
const Vision = require('./components/Vision').default;
const Product = require('./components/Product').default;
const Contact = require('./components/Contact').default;
const Footer = require('./components/Footer').default;
const AvatarDetails = require('./components/AvatarDetails').default;
const Trading = require('./pages/Trading').default;
const { StockAIRoutes } = require('./pages/StockAI/components/StockAILayout');

function AppShell() {
    const location = useLocation();
    const isTrading = location.pathname.startsWith('/trading');
    const isStockAI = location.pathname.startsWith('/stockai');
    const isLegacy = location.pathname.startsWith('/legacy');

    React.useEffect(() => {
      document.body.classList.toggle('site-dark', !isTrading && !isLegacy && !isStockAI);
      return () => document.body.classList.remove('site-dark');
    }, [isTrading, isLegacy, isStockAI]);

    if (isStockAI) {
      return (
        <div className="App App--stockai">
          <StockAIRoutes />
        </div>
      );
    }

    return (
      <div className={`App ${isLegacy ? 'App--legacy' : ''} ${!isTrading && !isLegacy ? 'App--studio' : ''}`}>
        {!isTrading && (isLegacy ? <Header /> : <SiteHeader />)}
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/team" element={<Team />} />
          <Route path="/vision" element={<Vision />} />
          <Route path="/product" element={<Navigate to="/legacy/product" replace />} />
          <Route path="/legacy/product" element={<Product legacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/avatar-details" element={<AvatarDetails />} />
          <Route path="/trading" element={<Trading />} />
          <Route path="/trading/heath" element={<Navigate to="/trading" replace />} />
          <Route path="/stockai/*" element={<StockAIRoutes />} />
        </Routes>
        {!isTrading && <Footer />}
      </div>
    );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;

export function mountMain() {
  const React = require('react');
  const ReactDOM = require('react-dom/client');
  const reportWebVitals = require('./reportWebVitals').default;
  require('./index.css');
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    React.createElement(React.StrictMode, null, React.createElement(App))
  );
  reportWebVitals();
}
